import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export const paddingVertical = byMedia(value => `
    padding-top: ${getPx(value)};
    padding-bottom: ${getPx(value)};
  `);
export const paddingHalfVertical = byMedia(value => `
    padding-top: calc(${getPx(value)} / 2);
    padding-bottom: calc(${getPx(value)} / 2);
  `);